import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CVLocalizationService } from '../services/cv-localization.service';

@Component({
    selector: 'cv-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

    @Input() title: string;
    @Input() prompt: string;
    @Input() isCXone: boolean;
    constructor(
        public modal: NgbActiveModal,
        public cvLocalizationService: CVLocalizationService,
    ) { }

    ngOnInit() {
        if (this.isCXone) {
            this.localizeText();
        }
    }

    async localizeText() {
        await this.cvLocalizationService.GetSection("CXOne_Dashboard");
        this.title = this.cvLocalizationService.getCachedText("CXOne_Dashboard", "Confirm_Redirect_Header", "Leave?");
        this.prompt = this.cvLocalizationService.getCachedText("CXOne_Dashboard", "Confirm_Redirect_Message1", "All changes will be lost.");
    }
}
